var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcRoundPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 22C2 10.9543 10.9543 2 22 2C33.0457 2 42 10.9543 42 22C42 33.0457 33.0457 42 22 42C10.9543 42 2 33.0457 2 22Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 23.6634H23.6666V31.9967C23.6666 32.4388 23.491 32.8627 23.1784 33.1753C22.8659 33.4878 22.4419 33.6634 21.9999 33.6634C21.5579 33.6634 21.134 33.4878 20.8214 33.1753C20.5088 32.8627 20.3333 32.4388 20.3333 31.9967V23.6634H11.9999C11.5579 23.6634 11.134 23.4878 10.8214 23.1753C10.5088 22.8627 10.3333 22.4388 10.3333 21.9967C10.3333 21.5547 10.5088 21.1308 10.8214 20.8182C11.134 20.5057 11.5579 20.3301 11.9999 20.3301H20.3333V11.9967C20.3333 11.5547 20.5088 11.1308 20.8214 10.8182C21.134 10.5057 21.5579 10.3301 21.9999 10.3301C22.4419 10.3301 22.8659 10.5057 23.1784 10.8182C23.491 11.1308 23.6666 11.5547 23.6666 11.9967V20.3301H31.9999C32.4419 20.3301 32.8659 20.5057 33.1784 20.8182C33.491 21.1308 33.6666 21.5547 33.6666 21.9967C33.6666 22.4388 33.491 22.8627 33.1784 23.1753C32.8659 23.4878 32.4419 23.6634 31.9999 23.6634Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 40C12.0589 40 4 31.9411 4 22H0C0 34.1503 9.84974 44 22 44V40ZM40 22C40 31.9411 31.9411 40 22 40V44C34.1503 44 44 34.1503 44 22H40ZM22 4C31.9411 4 40 12.0589 40 22H44C44 9.84974 34.1503 0 22 0V4ZM22 0C9.84974 0 0 9.84974 0 22H4C4 12.0589 12.0589 4 22 4V0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundPlus);
export default __webpack_public_path__ + "static/media/ic_round-plus.0070acfef841d14059ba39da6a75088a.svg";
export { ForwardRef as ReactComponent };